import { apiFetch, ApiError } from '@/lib/api';

type GetToken = () => Promise<string | null>;

/**
 * Download a single PDF or CSV (accounting) for a professional client invite.
 */
export async function downloadProfessionalSectionExport(
  getToken: GetToken,
  inviteId: number,
  section: string
): Promise<void> {
  const isCsv = section === 'accounting';
  const qs = new URLSearchParams({ section });
  const res = await apiFetch(
    getToken,
    `/v1/professional/clients/${inviteId}/export/pdf?${qs.toString()}`,
    {
      auth: true,
      headers: { Accept: isCsv ? 'text/csv,*/*' : 'application/pdf,*/*' },
    }
  );
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new ApiError(`Export failed: ${res.status}`, res.status, text);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = isCsv ? 'expenses-payments-export.csv' : `${section}-export.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}
